<template>
  <div ref="container">
    <slot />
  </div>
</template>

<script>
import Plyr from 'plyr'
import 'plyr/dist/plyr.css'

export default {
  name: 'VuePlyr',
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['ended'],
  data() {
    return { player: null }
  },
  mounted() {
    const el = this.$refs.container.querySelector('video, audio, div[data-plyr-provider]')
    if (el) {
      this.player = new Plyr(el, this.options)
      this.player.on('ended', () => this.$emit('ended'))
    }
  },
  beforeUnmount() {
    if (this.player) {
      this.player.destroy()
      this.player = null
    }
  }
}
</script>
